export default "__VITE_PUBLIC_ASSET__a187aebc__"